import { Box, Divider, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useState } from 'react';
import BlockUnblockAccountDialog from '@features/workspace/components/quick-links/block-unblock-accoount';
import { TraderootAccountActionType } from '@utils/traderoot';

export function QuickLinks() {
  const [accountBlockUnblock, setAccountBlockUnblock] = useState<null | string>(
    null
  );

  const quickActionsConfig: Array<any> = [
    {
      title: 'Account Settings',
      items: [
        {
          title: 'Suspend Account',
          handler: () =>
            setAccountBlockUnblock(TraderootAccountActionType.Block),
        },
        {
          title: 'Reactivate Account',
          handler: () =>
            setAccountBlockUnblock(TraderootAccountActionType.Unblock),
        },
      ],
    },
  ];

  return (
    <Box>
      <Typography variant="subtitle1">
        Frequent banking service requests
      </Typography>

      {quickActionsConfig.map((group) => (
        <Box key={group.title} display="flex" flexDirection="column">
          <Box display="flex" mb={1} mt={3}>
            <Typography variant="subtitle2">{group.title}</Typography>
          </Box>
          <Box display="flex" flexDirection="column">
            {group.items.map((quickAction: any, iQuickQuestion: number) => (
              <Box
                key={`${group.title}-${quickAction.title}`}
                display="flex"
                flexDirection="column"
              >
                <Box
                  alignItems="center"
                  display="flex"
                  flexDirection="row"
                  height="25px"
                  justifyContent="space-between"
                  my={1}
                  style={{
                    cursor: 'pointer',
                  }}
                  onClick={quickAction.handler}
                >
                  <Box display="flex" flexGrow={1}>
                    <Typography variant="body1">{quickAction.title}</Typography>
                  </Box>
                  <Box display="flex">
                    <ExpandMoreIcon style={{ transform: 'rotate(-90deg)' }} />
                  </Box>
                </Box>
                {iQuickQuestion < group.items.length - 1 && (
                  <Box>
                    <Divider />
                  </Box>
                )}
              </Box>
            ))}
          </Box>
        </Box>
      ))}

      {/* Feature dialogs */}
      <BlockUnblockAccountDialog
        action={accountBlockUnblock}
        open={!!accountBlockUnblock}
        onClose={() => setAccountBlockUnblock(null)}
      />
    </Box>
  );
}
